import queryString from 'query-string';
import { SyntheticEvent, useCallback, useEffect, useState } from 'react';
import { batch, connect } from 'react-redux';
import { useNavigationType } from 'react-router-dom';

import { SearchSection } from 'api/types/shared.types';
import {
  InputPrefixVariant,
  InputStyleVariant,
} from 'components/Input/Input.styled';
import { SearchInputs } from 'components/Search/SearchInputs';
import {
  MainStoreMainSearchState as MainSearch,
  clearSearchLocation as clearSearchLocationAction,
  initializeLandingPageSearch as initializeLandingPageSearchAction,
  initializeSearch as initializeSearchAction,
  setPageIndex as setPageIndexAction,
  setSearchFilter as setSearchFilterAction,
  setSearchQuery as setSearchQueryAction,
  setUserInitiatedSearch as setUserInitiatedSearchAction,
  updateSearchLocation as updateSearchLocationAction,
} from 'modules/main/store/ducks/mainSearch';
import { showModal as showModalAction } from 'modules/main/store/ducks/modal';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import {
  DisplayedType,
  EMPTY_SEARCH_LOCATION,
  listingTypesBySection,
} from 'utils/constants';
import { stringify } from 'utils/functional';
import { listingSearchHome } from 'utils/searchHomePages';
import { truncateToUTF8Bytes } from 'utils/string';
import { getFirstParam } from 'utils/url';
import { RouteComponentProps, withRouter } from 'utils/withRouter';

type InitialProps = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearch?: (arg0: Record<string, any>) => void;
  searchSection: SearchSection;
  inPageHeader?: boolean;
  searchFrom?: string;
  defaultSearchType?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types
  isStaff?: boolean;
  searchMode?: boolean;
  prefixVariant?: InputPrefixVariant;
  styleVariant?: InputStyleVariant;
};
type OwnProps = InitialProps & RouteComponentProps;
type Props = OwnProps & {
  searchSection: SearchSection;
  type: ListingType;
  query: string;
  mainSearch: MainSearch | null | undefined;
  setUserInitiatedSearch: () => unknown;
  setPageIndex: (arg0: number, arg1: boolean) => unknown;
  setSearchQuery: (arg0: string, arg1: boolean) => unknown;
  setSearchFilter: (arg0: string, arg1: unknown) => unknown;
  updateSearchLocation: (
    arg0: SearchLocation,
    arg1: boolean
  ) => Promise<unknown>;
  clearSearchLocation: (arg0: boolean) => Promise<unknown>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
  initializeLandingPageSearch: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
  initializeSearch: (...args: Array<any>) => any;
  defaultSearchType: ListingType | null | undefined;
  searchMode: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showModal: (...args: Array<any>) => any;
};

function SearchInputsContainer(props: Props) {
  const {
    location: reactRouterLocation,
    searchSection,
    updateSearchLocation,
    styleVariant,
    prefixVariant,
  } = props;
  const navigationType = useNavigationType();
  const { user } = useUserEnvironment();
  const [listingTypes] = useState<Array<DisplayedType>>(
    listingTypesBySection[searchSection]
  );
  const [type, setType] = useState<ListingType>(
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.type || props.defaultSearchType || listingTypes[0]
  );
  const [query, setQuery] = useState(
    truncateToUTF8Bytes(
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      props.query || getFirstParam(props.location, 'q') || '',
      512
    )
  );
  const [enqueueSearch, setEnqueueSearch] = useState([false, null]);
  const [location, setLocation] = useState<SearchLocation | null | undefined>(
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
    // eslint-disable-next-line react/destructuring-assignment
    props.mainSearch.searchLocation
  );
  useEffect(
    () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (props.defaultSearchType) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        setType(props.defaultSearchType);
      }
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    [props.defaultSearchType]
  );
  useEffect(
    () => {
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
      // eslint-disable-next-line react/destructuring-assignment
      setLocation(props.mainSearch.searchLocation);
    }, // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
    // eslint-disable-next-line react/destructuring-assignment
    [props.mainSearch.searchLocation]
  );

  useEffect(() => {
    if (navigationType === 'POP') {
      const queryParams = queryString.parse(reactRouterLocation.search);

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (typeof queryParams.q === 'string' && queryParams.q !== props.query) {
        setQuery(truncateToUTF8Bytes(queryParams.q || '', 512));
      }
    }
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
  }, [reactRouterLocation, navigationType, props.query]);

  const setListingType = setType;
  const setUserQuery = useCallback(
    (q: string) => {
      // Algolia has a max query length of 512 bytes
      setQuery(truncateToUTF8Bytes(q, 512));
    },
    [setQuery]
  );

  const setSearchLocation = (
    searchLocation: SearchLocation | null | undefined,
    shouldEnqueueSearch = true,
    setRemote = false
  ) => {
    setLocation(searchLocation);

    if (!searchLocation) {
      // @ts-expect-error TS(2345): Argument of type '{ boundingBoxE: null; boundingBo... Remove this comment to see the full error message
      updateSearchLocation(EMPTY_SEARCH_LOCATION, true);
    }

    if (setRemote) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      props.setSearchFilter('locationTypeFacet', [
        'REMOTE',
        'REMOTE_TEMPORARY',
      ]);
    }

    if (shouldEnqueueSearch) {
      // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'boolean |... Remove this comment to see the full error message
      setEnqueueSearch([true, query]);
    }
  };

  const search = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (stateQuery: any) => {
      const {
        clearSearchLocation,
        setUserInitiatedSearch,
        navigate,
        searchFrom,
        searchMode,
        setSearchFilter,
        setSearchQuery,
      } = props;
      const stateSearchLocation = location;
      const stateType = type;

      const finalQuery = stateQuery;

      batch(() => {
        // TODO: Fix this the next time the file is edited.
        // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
        // eslint-disable-next-line react/destructuring-assignment
        const mainSearchLocationAddress = props.mainSearch.searchLocation
          ? // TODO: Fix this the next time the file is edited.
            // @ts-expect-error TS(2533): Object is possibly 'null' or 'undefined'.
            // eslint-disable-next-line react/destructuring-assignment
            props.mainSearch.searchLocation.latLongAddress
          : undefined;

        const stateSearchLocationAddress = stateSearchLocation
          ? // @ts-expect-error TS(2339): Property 'latLongAddress' does not exist on type '... Remove this comment to see the full error message
            stateSearchLocation.latLongAddress
          : undefined;

        const locationsMatch =
          mainSearchLocationAddress === stateSearchLocationAddress;

        if (!locationsMatch) {
          if (stateSearchLocation) {
            updateSearchLocation(stateSearchLocation, true).then(() =>
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/destructuring-assignment
              props.setPageIndex(0, false)
            );
          } else {
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            clearSearchLocation(true).then(() => props.setPageIndex(0, false));
          }
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (props.type && stateType !== props.type) {
          setSearchFilter('type', stateType);

          if (stateType === 'VOLOP') {
            setSearchFilter('actionTypeFacet', ['VOLOP']);
          }
        }

        setSearchQuery(stateQuery, true);
      });

      const searchHome = listingSearchHome(stateType);
      const queryParams = queryString.parse(reactRouterLocation.search);

      if (searchHome && (!searchMode || (!queryParams.q && queryParams.pq))) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (finalQuery && finalQuery === props.query) {
          navigate(`${searchHome}?q=${encodeURIComponent(finalQuery)}`, {
            state: {
              searchFrom,
            },
            replace: true,
          });
        } else {
          navigate(`${searchHome}?q=${encodeURIComponent(finalQuery)}`, {
            state: {
              searchFrom,
            },
          });
        }

        setUserInitiatedSearch();
      }
    },
    [props, location, type, updateSearchLocation, reactRouterLocation]
  );
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/destructuring-assignment
  const redirectTo = props.location
    ? // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      `${props.location.pathname}${props.location.search}`
    : '';

  const clickLogin = (e: SyntheticEvent) => {
    e.preventDefault();
    trackClicked('Log In Search Hero');
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.showModal('LOGIN', {
      redirectTo,
    });
  };

  const clickSignup = (e: SyntheticEvent) => {
    e.preventDefault();
    trackClicked('Sign Up Search Hero');
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.showModal('SIGNUP', {
      redirectTo,
    });
  };

  const redirectParam = queryString.stringify({
    to: redirectTo,
  });
  useEffect(() => {
    const [enqueued, searchQuery] = enqueueSearch;

    if (enqueued) {
      setEnqueueSearch([false, null]);
      search(stringify(searchQuery));
    }
  }, [enqueueSearch, props, search]);
  const clearSearchInput = useCallback(
    () => {
      setUserQuery('');

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (props.searchMode) {
        search('');
      }
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    [setUserQuery, search, props.searchMode]
  );
  const selectedType =
    listingTypes.find((l) => l === type) ||
    (listingTypes.includes('JOB') ? 'JOB' : listingTypes[0]);
  return (
    <SearchInputs
      listingTypes={listingTypes}
      selectedType={selectedType}
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error TS(2322): Type '((arg0: Record<string, any>) => void) | unde... Remove this comment to see the full error message
      // eslint-disable-next-line react/destructuring-assignment
      onSearch={props.onSearch}
      query={query}
      searchLocation={location}
      setListingType={setListingType}
      setQuery={setUserQuery}
      clearSearchInput={clearSearchInput}
      redirectParam={redirectParam}
      setSearchLocation={setSearchLocation}
      search={search}
      placeholder={getText('Search by keyword, skill, or interest')}
      xsPlaceholder={getText('Keyword, skill, or interest')}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      inPageHeader={props.inPageHeader}
      clickLogin={clickLogin}
      clickSignup={clickSignup}
      showLogin={!user}
      prefixVariant={prefixVariant}
      styleVariant={styleVariant}
    />
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = ({ mainSearch }: any) => ({
  mainSearch,
  query: mainSearch ? mainSearch.query : '',
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  type: mainSearch && mainSearch.filters && mainSearch.filters.type,
});

// eslint-disable-next-line import/no-default-export
export default withRouter(
  connect(mapStateToProps, {
    setUserInitiatedSearch: setUserInitiatedSearchAction,
    setSearchFilter: setSearchFilterAction,
    setPageIndex: setPageIndexAction,
    setSearchQuery: setSearchQueryAction,
    updateSearchLocation: updateSearchLocationAction,
    clearSearchLocation: clearSearchLocationAction,
    initializeSearch: initializeSearchAction,
    initializeLandingPageSearch: initializeLandingPageSearchAction,
    showModal: showModalAction,
  })(SearchInputsContainer)
);
